import { useClientTranslations } from "../../lib/i18n/client";
import styles from "./SessionTimeoutWarningModal.module.css";

interface SessionTimeoutWarningModalProps {
	countdown: number;
	onStayLoggedIn: () => void;
	onLogOut: () => void;
}

function formatCountdown(totalSeconds: number): string {
	const m = Math.floor(totalSeconds / 60);
	const s = totalSeconds % 60;
	return `${m}:${String(s).padStart(2, "0")}`;
}

export function SessionTimeoutWarningModal({
	countdown,
	onStayLoggedIn,
	onLogOut,
}: SessionTimeoutWarningModalProps) {
	const { t, direction } = useClientTranslations("session");

	return (
		<div className={styles.overlay}>
			<div className={styles.modal} dir={direction}>
				{/* Warning/clock icon */}
				<svg
					className={styles.icon}
					fill="none"
					stroke="currentColor"
					viewBox="0 0 24 24"
				>
					<title>Session warning</title>
					<path
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth={2}
						d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
					/>
				</svg>

				<h2 className={styles.title}>{t("warning.title")}</h2>
				<p className={styles.body}>
					{t("warning.body", { time: formatCountdown(countdown) })}
				</p>

				<div className={styles.buttonGroup}>
					<button
						type="button"
						onClick={onLogOut}
						className={`${styles.button} ${styles.logOutButton}`}
					>
						{t("warning.logOut")}
					</button>
					<button
						type="button"
						onClick={onStayLoggedIn}
						className={`${styles.button} ${styles.stayButton}`}
					>
						{t("warning.stayLoggedIn")}
					</button>
				</div>
			</div>
		</div>
	);
}
